import accessingData from './accessingData.gif';
import aggregation from './aggregation.gif';
import alignedGrids from './alignedGrids.gif';
import animation from './animation.gif';
import cellEditing from './cellEditing.gif';
import cellRendering from './cellRendering.gif';
import cellStyling from './cellStyling.gif';
import changeDetection from './changeDetection.gif';
import clipboard from './clipboard.gif';
import columnDefinitions from './columnDefinitions.gif';
import columnGroups from './columnGroups.gif';
import columnHeaders from './columnHeaders.gif';
import columnMenu from './columnMenu.gif';
import columnMoving from './columnMoving.gif';
import columnPinning from './columnPinning.gif';
import columnResizing from './columnResizing.gif';
import columnSpanning from './columnSpanning.gif';
import contextMenu from './contextMenu.gif';
import csvExport from './csvExport.gif';
import customFilter from './customFilter.gif';
import customIcons from './customIcons.gif';
import dateFilter from './dateFilter.gif';
import excelExport from './excelExport.gif';
import externalFilter from './externalFilter.gif';
import fullWidthRows from './fullWidthRows.gif';
import gridSize from './gridSize.gif';
import groupingRows from './groupingRows.gif';
import keyboardNavigation from './keyboardNavigation.gif';
import localisation from './localisation.gif';
import masterDetail from './masterDetail.gif';
import numberFilter from './numberFilter.gif';
import overlays from './overlays.gif';
import pagination from './pagination.gif';
import performance from './performance.gif';
import pivoting from './pivoting.gif';
import quickFilter from './quickFilter.gif';
import rangeSelection from './rangeSelection.gif';
import rowDragging from './rowDragging.gif';
import rowHeight from './rowHeight.gif';
import rowPinning from './rowPinning.gif';
import rowSelection from './rowSelection.gif';
import rowSorting from './rowSorting.gif';
import rtl from './rtl.gif';
import setFilter from './setFilter.gif';
import statusBar from './statusBar.gif';
import textFilter from './textFilter.gif';
import toolPanel from './toolPanel.gif';
import touchSupport from './touchSupport.gif';
import treeData from './treeData.gif';
import updatingData from './updatingData.gif';
import viewRefresh from './viewRefresh.gif';

export default {
    accessingData,
    aggregation,
    alignedGrids,
    animation,
    cellEditing,
    cellRendering,
    cellStyling,
    changeDetection,
    clipboard,
    columnDefinitions,
    columnGroups,
    columnHeaders,
    columnMenu,
    columnMoving,
    columnPinning,
    columnResizing,
    columnSpanning,
    contextMenu,
    csvExport,
    customFilter,
    customIcons,
    dateFilter,
    excelExport,
    externalFilter,
    fullWidthRows,
    gridSize,
    groupingRows,
    keyboardNavigation,
    localisation,
    masterDetail,
    numberFilter,
    overlays,
    pagination,
    performance,
    pivoting,
    quickFilter,
    rangeSelection,
    rowDragging,
    rowHeight,
    rowPinning,
    rowSelection,
    rowSorting,
    rtl,
    setFilter,
    statusBar,
    textFilter,
    toolPanel,
    touchSupport,
    treeData,
    updatingData,
    viewRefresh,
};